import { render, staticRenderFns } from "./IqitFreeDeliveryCount.vue?vue&type=template&id=06be1a84&"
import script from "./IqitFreeDeliveryCount.vue?vue&type=script&lang=js&"
export * from "./IqitFreeDeliveryCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports